import React, { useCallback, useEffect, useState } from 'react';
import { getSummaryOnePointFive } from '@oneaudi/stck-store/dist/selectors/financeSelector';
import { Iframe } from '../../../../components/layer/Iframe';
import { readFinance } from '../../../utils/sessionStorage';
import { getAozProductsFromSession } from '../../../utils/aozSessionStorage';
export function usePostData(vehicle, dataProfile, vehicleRaw) {
    var _a;
    const [postData, setPostData] = useState('');
    const skuItems = (_a = vehicleRaw === null || vehicleRaw === void 0 ? void 0 : vehicleRaw.detail) === null || _a === void 0 ? void 0 : _a.skuItems;
    useEffect(() => {
        function generatePostData() {
            var _a;
            const finance = (_a = readFinance(vehicle.type)) !== null && _a !== void 0 ? _a : {};
            const financing = dataProfile !== 'no-finance-data' ? getSummaryOnePointFive(finance, vehicle.id) : finance;
            const products = getAozProductsFromSession(vehicle);
            const dealerIds = [];
            const postDataString = JSON.stringify([
                { aoz: products },
                { audicode: vehicle.audiCode },
                { financingData: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.financing) ? financing : undefined },
                { vehicleData: vehicle },
                { dealerFilterIds: dealerIds },
                { skuItems },
            ]);
            setPostData(postDataString);
        }
        generatePostData();
    }, [vehicle, dataProfile, vehicleRaw]);
    return postData;
}
export const PostFormV2 = ({ link, postData, }) => {
    const formRef = useCallback((form) => {
        if (form) {
            form.submit();
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { action: link.url, id: "tile-post-form", target: "cta-iframe", method: "post", hidden: true, ref: formRef },
            React.createElement("input", { type: "hidden", name: "inquiry_json_data", value: postData })),
        React.createElement(Iframe, { src: "", originUrl: link.url })));
};
